import { Injectable } from "@angular/core";

@Injectable()
export abstract class EnvironmentService {
    abstract getApiUrl(): string;
    abstract getMsalGuardScopes(): string[];
}